import React, { useState } from "react";
import { addTierMap, fetchTierMap } from "@/slices/LocationSlice/tierMapSlice";
import { useDispatch } from "react-redux";

function AddTierMapper({ state, district, city, tier }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    State: "",
    District: "",
    City: "",
    Tier: "",
    val: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const resp = await dispatch(addTierMap(formData));
    if(!resp.error){
      dispatch(fetchTierMap())
    }

  };

  return (
    <form
      onSubmit={handleSubmit}
      className="max-w-2xl mx-auto p-6 bg-white shadow rounded space-y-4"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* State */}
        <div>
          <label className="block font-medium mb-1">State</label>
          <select
            name="State"
            value={formData.State}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select State</option>
            {state?.map((s) => (
              <option key={s.id} value={s.id}>
                {s.title}
              </option>
            ))}
          </select>
        </div>

        {/* District */}
        <div>
          <label className="block font-medium mb-1">District</label>
          <select
            name="District"
            value={formData.District}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select District</option>
            {district?.map((d) => (
              <option key={d.id} value={d.id}>
                {d.title}
              </option>
            ))}
          </select>
        </div>

        {/* City */}
        <div>
          <label className="block font-medium mb-1">City</label>
          <select
            name="City"
            value={formData.City}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select City</option>
            {city?.map((c) => (
              <option key={c.id} value={c.id}>
                {c.title}
              </option>
            ))}
          </select>
        </div>

        {/* Tier */}
        <div>
          <label className="block font-medium mb-1">Tier</label>
          <select
            name="Tier"
            value={formData.Tier}
            onChange={handleChange}
            required
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Select Tier</option>
            {tier?.map((t) => (
              <option key={t.id} value={t.id}>
                {t.title}
              </option>
            ))}
          </select>
        </div>

        {/* Val (full width) */}
        <div className="md:col-span-2">
          <label className="block font-medium mb-1">Val</label>
          <input
            type="text"
            name="val"
            value={formData.val}
            onChange={handleChange}
            required
            placeholder="Enter value"
            className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>

      <button
        type="submit"
        className="w-full bg-blue-600 text-white font-semibold py-2 rounded hover:bg-blue-700 transition"
      >
        Submit
      </button>
    </form>
  );
}

export default AddTierMapper;
